import apiClient from './apiClient';

/**
 * Creates a new trainer.
 * @param {object} trainerData - The data for the new trainer (e.g., { email, full_name, phone }).
 * @returns {Promise<object>} The response from the API.
 */
export const createTrainer = (trainerData) => {
  return apiClient('/trainers', { body: trainerData, method: 'POST' });
};

/**
 * Fetches a list of all trainers.
 * @returns {Promise<Array>} A promise that resolves to an array of trainers.
 */
export const getTrainers = () => {
  return apiClient('/trainers');
};

/**
 * Updates an existing trainer.
 * @param {string} trainerId - The ID of the trainer to update.
 * @param {object} trainerData - The updated data for the trainer.
 * @returns {Promise<object>} A promise that resolves to the updated trainer data.
 */
export const updateTrainer = (trainerId, trainerData) => {
  return apiClient(`/trainers/${trainerId}`, { body: trainerData, method: 'PUT' });
};

/**
 * Deletes a trainer.
 * @param {string} trainerId - The ID of the trainer to delete.
 * @returns {Promise<object>} A promise that resolves when the trainer is deleted.
 */
export const deleteTrainer = (trainerId) => {
  return apiClient(`/trainers/${trainerId}`, { method: 'DELETE' });
};

/**
 * Fetches courses for a specific trainer.
 * @param {string|number} trainerId - The ID of the trainer.
 * @returns {Promise<Array>} A promise that resolves to an array of courses.
 */
export const getTrainerCourses = (trainerId) => {
  return apiClient(`/trainers/${trainerId}/courses`);
}; 